import { RouteConfig } from "vue-router";

const metaAuth = {
    auth: [1],
};

const routes: RouteConfig[] = [
    {
        path: "/",
        redirect: "/home",
    },
    {
        path: "/home",
        name: "home",
        meta: metaAuth,
        // 渠道包需要修改home路由对应的组件，例如baidu01: @/views/Home/pages/baidu01/index.vue
        component: () => import("@/views/Home/pages/default/index.vue"),
    },
    {
        path: "/toIosChannel",
        name: "toIosChannel",
        component: () => import("@/views/Home/pages/toIosChannel/index.vue"),
    },
    {
        path: "/baidu",
        name: "baidu",
        component: () => import("@/views/Home/pages/baidu/index.vue"),
    },
    {
        path: "/baidu01",
        name: "baidu01",
        component: () => import("@/views/Home/pages/baidu01/index.vue"),
    },
    {
        path: "/baidu02",
        name: "baidu02",
        component: () => import("@/views/Home/pages/baidu02/index.vue"),
    },
    {
        path: "/by01",
        name: "by01",
        component: () => import("@/views/Home/pages/by01/index.vue"),
    },
    {
        path: "/360",
        name: "360",
        component: () => import("@/views/Home/pages/360/index.vue"),
    },
    {
        path: "/36001",
        name: "36001",
        component: () => import("@/views/Home/pages/36001/index.vue"),
    },
    {
        path: "/36002",
        name: "36002",
        component: () => import("@/views/Home/pages/36002/index.vue"),
    },
];

export default routes;
